import React from 'react'

// Ícone de documento (usa currentColor, então herda a cor do texto do botão).
export function FilePdfIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6zm4 18H6V4h7v5h5v11z"
      />
      <path
        fill="currentColor"
        d="M8 10h4v1.5H8V10zm0 3h8v1.5H8V13zm0 3h8v1.5H8V16z"
      />
    </svg>
  )
}
